import Vue from 'vue';
import VueRouter from 'vue-router';
import Welcome from '../views/Welcome.vue';
import NotFound from '../views/NotFound.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: () => import(
      /* webpackChunkName: "step" */
      '../views/Introduction.vue'
    ),
    props: {
      step: true,
    },
  },
  {
    path: '/country-selection',
    name: 'Country Selection',
    component: () => import(
      /* webpackChunkName: "country-selection" */
      '../views/Selection.vue'
    ),
  },
  {
    path: '/country/:country/:step(\\d+)',
    name: 'Country Step',
    component: () => import(
      /* webpackChunkName: "step" */
      '../views/Step.vue'
    ),
    props: {
      country: true,
      step: true,
      severities: true,
    },
  },
  {
    path: '/country/:country/results',
    name: 'Results',
    component: () => import(
      /* webpackChunkName: "results" */
      '../views/Results.vue'
    ),
    props: {
      country: true,
      severities: true,
    },
  },
  {
    // 404 Not found page.
    path: '*',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
